import { PointAddResponse } from "@1games-ru/region-shared/dist/client/requests/point";
import { useCallback, useEffect, useState } from "react";
import { Button, Icon, TextInput } from "@/shared/ui";
import { Point } from "@/domains/createEntity/constants/point";
import getInitPoint from "@/domains/createEntity/helpers/getInitPoint";
import toast from "@/domains/toasts/helpers/toast";
import useCreateGasStation from "@/domains/createEntity/hooks/useCreateGasStation";
import usePoint from "@/domains/createEntity/hooks/usePoint";
import CreateEntityColumn from "@/domains/createEntity/components/CreateEntityColumn";
import CreateEntityRow from "@/domains/createEntity/components/CreateEntityRow";
import CreateEntityScroll from "@/domains/createEntity/components/CreateEntityScroll";
import CreateEntityTitle from "@/domains/createEntity/components/CreateEntityTitle";

type Props = {
  onClose?: () => void;
};

export default function CrateEntityGasStationFormContainer({ onClose }: Props) {
  const { addPoint, clearPoints } = usePoint();
  const { createGasStation } = useCreateGasStation();
  const [businessId, setBusinessId] = useState("");
  const [fillingPoints, setFillingPoints] = useState<PointAddResponse[]>([]);

  const clear = useCallback(async () => {
    const response = await clearPoints();
    if (response) {
      setBusinessId("");
      setFillingPoints([]);
    }
  }, []);

  useEffect(() => {
    return () => {
      clear();
    };
  }, []);

  const addColumn = useCallback(async () => {
    const point = await addPoint(getInitPoint(Point.GasStationColumnLocation));
    if (point) {
      setFillingPoints((state) => [...state, point]);
    }
  }, []);

  const deleteColumn = useCallback(async (point: PointAddResponse) => {
    // TODO: запрос
    setFillingPoints((state) => state.filter((item) => item.id !== point.id));
  }, []);

  const createHandler = useCallback(async () => {
    if (!businessId) {
      toast.error("Заполните все поля");
      return;
    }
    const response = await createGasStation({
      businessId: Number(businessId),
      fillingPositions: fillingPoints.map((item) => item.position),
    });
    if (response) {
      clear();
    }
  }, [createGasStation, fillingPoints, businessId, clear]);

  return (
    <>
      <CreateEntityTitle title="Заправка" onClose={onClose} />
      <CreateEntityScroll>
        <div className="flex flex-col gap-3.5">
          <CreateEntityRow label="Название заправки">
            <TextInput
              value={businessId}
              onChange={setBusinessId}
              placeholder="Введите айди бизнеса"
            />
          </CreateEntityRow>
          <CreateEntityRow label="Местоположение колонок">
            <div className="flex flex-col gap-1.5">
              {fillingPoints.map((item, index) => (
                <CreateEntityColumn
                  key={`${-index}`}
                  title="Колонка"
                  onDelete={() => deleteColumn(item)}
                  index={index + 1}
                />
              ))}
              <Button
                data-mz-accent="success"
                className="w-full flex items-center justify-between h-[2.625rem] shrink-0 mt-1"
                onClick={addColumn}
              >
                Добавить колонку
                <Icon name="save" className="w-4" />
              </Button>
            </div>
          </CreateEntityRow>
        </div>
      </CreateEntityScroll>
      <Button onClick={createHandler}>Создать заправку</Button>
    </>
  );
}
